// Fixed color+shape per option position (not per question) so students learn
// "red triangle = option 1" and can answer without reading, Kahoot-style.
export const MC_STYLES = [
  { shape: '▲', colorVar: '--shape-0', name: 'สามเหลี่ยม' },
  { shape: '◆', colorVar: '--shape-1', name: 'เพชร' },
  { shape: '●', colorVar: '--shape-2', name: 'วงกลม' },
  { shape: '■', colorVar: '--shape-3', name: 'สี่เหลี่ยม' },
];
